export default __webpack_public_path__ + "static/troops-return-ad657c4a07a47ba8b9fe79c799b103ee.png";